export default "__VITE_ASSET__BkKG99XL__"